import React, { Component } from 'react'
import { Switch, Redirect, Route, Link, withRouter } from 'react-router-dom'
import Color from 'color'
import { palette } from '../../Theme/Theme'
import { connect } from 'react-redux'
import injectSheet from 'react-jss'
import Signup from './Signup.jsx'
import Signin from './Signin.jsx'
import LoginHelp from './LoginHelp.jsx'
import Logo from './Logo'
import ResetPassword from './ResetPassword'
import Responsive from 'react-responsive'
import Browse from './Browse.jsx'
const Desktop = props => <Responsive {...props} minWidth={736}/>
const Mobile = props => <Responsive {...props} maxWidth={735}/>

class LandingPage extends Component {
  render () {
    const { classes, match, user } = this.props
    if (user) {
      return <Redirect to='/'/>
    }
    return (
      <div className={classes.test}>
        <img src="../../../Assets/flat_grid_bright.png" alt='' className={classes.Image}/>
        <div className={classes.Container}>
          <Desktop>
            <div className={classes.Header}>
              {this.props.location.pathname !== '/welcome' ? this.renderLogo() : this.renderPlaceHolder()}
              <div>
                <Link style={{zIndex: '100'}} className={classes.NavButton} to={match.url + '/signin'}>Sign In</Link>
                <Link className={classes.NavButton} to={match.url + '/signup'}>Sign Up</Link>
              </div>
            </div>
          </Desktop>
          <Mobile>
            <div className={classes.HeaderMobile}>
              {this.props.location.pathname !== '/welcome' ? this.renderLogo() : this.renderPlaceHolder()}
              <div>
                <Link className={classes.NavButtonMobile} to={match.url + '/signin'}>Sign In</Link>
                <Link className={classes.NavButtonMobile} to={match.url + '/signup'}>Sign Up</Link>
              </div>
            </div>
          </Mobile>
          <div>

          </div>
          <div className={classes.Body}>
            <Switch>
              <Route exact path='/welcome' component={Logo}/>
              <Route path='/welcome/loginHelp' component={LoginHelp}/>
              <Route path='/welcome/ResetPassword/:token' component={ResetPassword}/>
              <Route path='/welcome/signin' component={Signin}/>
              <Route path='/welcome/signup' component={Signup}/>
              {/* <Route exact path='/welcome/browse' component={Browse}/> */}
              <Redirect to='/welcome'/>
            </Switch>
          </div>
          <Desktop>
            <div className={classes.Footer}>
              <span className={classes.FooterGroup}>
                <a className={classes.IconLink} rel="noopener noreferrer" href="https://www.facebook.com/spectivinc/" target='_blank'>
                  <span className={classes.IconLink}><i className="fa-fw fab fa-facebook-square"/></span>
                </a>
                <a className={classes.IconLink} rel="noopener noreferrer" href="https://twitter.com/spectivmedia" target='_blank'>
                  <span className={classes.IconLink}><i className="fa-fw fab fa-twitter-square"/></span>
                </a>
                <a className={classes.IconLink} rel="noopener noreferrer" href="https://www.instagram.com/spectiv/" target='_blank'>
                  <span className={classes.IconLink}><i className="fa-fw fab fa-instagram"/></span>
                </a>

                <div style={{width: '1px', height: '1.5rem', margin: '0 .5rem', background: 'rgb(70, 70, 70)', display: 'inline-block'}}/>

                <a className={classes.IconLink} rel="noopener noreferrer" target='_blank' href="https://channelstore.roku.com/details/154913/spectiv">
                  <span style={{fontWeight: '700'}}>R<span style={{fontSize: '1.2rem'}}>OKU</span></span>
                </a>
                <a className={classes.IconLink} href="https://itunes.apple.com/us/app/spectiv/id1286699781?mt=8">
                  <span className={classes.IconLink}><i className="fa-fw fab fa-apple"/></span>
                </a>

                <div style={{width: '1px', height: '1.5rem', margin: '0 .5rem', background: 'rgb(70, 70, 70)', display: 'inline-block'}}/>
                <a className={classes.IconLink} rel="noopener noreferrer" href="https://www.spectiv.co" target='_blank'>
                  <span className={classes.IconLink} style={{fontSize: '1.2rem'}}>Learn More</span>
                </a>
                <div style={{width: '1px', height: '1.5rem', margin: '0 .5rem', background: 'rgb(70, 70, 70)', display: 'inline-block'}}/>
              <a className={classes.IconLink} rel="noopener noreferrer" href="https://spectiv.co/Engage/Contact" target='_blank'>
                <span className={classes.IconLink} style={{fontSize: '1.2rem'}}>Contact Us</span>
              </a>
              </span>
            </div>
          </Desktop>
          <Mobile>
            <div className={classes.Footer} style={{width: '100vw', maxWidth: '100vw', marginTop: '10vh'}}>
              <span className={classes.FooterGroup} style={{justifyContent: 'space-around'}}>
                <a className={classes.IconLinkMobile} rel="noopener noreferrer" href="https://www.facebook.com/spectivinc/" target='_blank'>
                  <span className={classes.IconLinkMobile}><i className="fa-fw fab fa-facebook-square"/></span>
                </a>
                <a className={classes.IconLinkMobile} rel="noopener noreferrer" href="https://twitter.com/spectivmedia" target='_blank'>
                  <span className={classes.IconLinkMobile}><i className="fa-fw fab fa-twitter-square"/></span>
                </a>
                <a className={classes.IconLinkMobile} rel="noopener noreferrer" href="https://www.instagram.com/spectiv/" target='_blank'>
                  <span className={classes.IconLinkMobile}><i className="fa-fw fab fa-instagram"/></span>
                </a>

                <div style={{width: '1px', height: '1.5rem', margin: '0 .5rem', background: 'rgb(70, 70, 70)', display: 'inline-block'}}/>

                <a className={classes.IconLinkMobile} rel="noopener noreferrer" target='_blank' href="https://channelstore.roku.com/details/154913/spectiv">
                  <span style={{fontWeight: '700'}}>R<span style={{fontSize: '1.2rem'}}>OKU</span></span>
                </a>
                <a className={classes.IconLinkMobile} href="https://itunes.apple.com/us/app/spectiv/id1286699781?mt=8">
                  <span className={classes.IconLinkMobile}><i className="fa-fw fab fa-apple"/></span>
                </a>

                <div style={{width: '1px', height: '1.5rem', margin: '0 .5rem', background: 'rgb(70, 70, 70)', display: 'inline-block'}}/>
                <a className={classes.IconLinkMobile} style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center'}} rel="noopener noreferrer" href="https://www.spectiv.co" target='_blank'>
                  <span className={classes.IconLinkMobile} style={{fontSize: '1rem', alignItems: 'center'}}>Learn</span><span className={classes.IconLinkMobile} style={{fontSize: '1rem', alignItems: 'center'}}>More</span>
                </a>
                <div style={{width: '1px', height: '1.5rem', margin: '0 .5rem', background: 'rgb(70, 70, 70)', display: 'inline-block'}}/>
                <a className={classes.IconLinkMobile} style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center'}} rel="noopener noreferrer" href="https://spectiv.co/Engage/Contact" target='_blank'>
                  <span className={classes.IconLinkMobile} style={{fontSize: '1rem', alignItems: 'center'}}>Contact</span><span className={classes.IconLink} style={{fontSize: '1rem', alignItems: 'center'}}>Us</span>
                </a>
              </span>
            </div>
          </Mobile>
        </div>
      </div>
    )
  }

  renderLogo () {
    const { classes } = this.props
    return (
      <Link to="/welcome" className={classes.imgContainer}>
        <img src="../../../Assets/spectiv_light_medium.png" className={classes.logoSmall} alt=''/>
      </Link>
    )
  }
  renderPlaceHolder () {
    const { classes } = this.props
    return (
      <Link to="/welcome" className={classes.imgContainer}>
        <img src="../../../Assets/spectiv_light_medium.png" style={{opacity: '0'}} className={classes.logoSmall} alt=''/>
      </Link>
    )
  }
}

const styles = {
  logoSmall: {
    width: '9vw',
    transition: 'all .4s',
    margin: '.5rem',
    minWidth: '8rem'
  },
  FlexRow: {
    display: 'flex',
    flexDirection: 'row'
  },
  FlexColumn: {
    display: 'flex',
    flexDirection: 'column'
  },
  FlexCenter: {
    justifyContent: 'center',
    alignItems: 'center'
  },
  Image: {
    position: 'fixed',
    width: '100vw',
    height: '100vh',
    top: '0', left: '0',
    filter: 'blur(20px)',
    zIndex: '-2',    
  },
  Container: {
    background: `linear-gradient(45deg, ${Color(palette.pink).darken(0.7).alpha(0.9)}, ${Color(palette.purple).darken(0.7).alpha(0.9)}, ${Color(palette.blue).darken(0.7).alpha(0.9)}, ${Color(palette.teal).darken(0.7).alpha(0.9)})`,
    width: '100vw',
    minHeight: '100vh',
    zIndex: '100',
  },
  Header: {
    composes: ['$FlexRow'],
    padding: '.5rem',
    justifyContent: 'space-between',
    height: '10vh'
  },
  HeaderMobile: {
    extend: 'Header'
  },
  Body: {
    composes: ['$FlexRow', '$FlexCenter'],
    width: '100%',
    height: '80vh',
    // background: `linear-gradient(45deg, ${Color(palette.pink).darken(0.7).alpha(0.9)}, ${Color(palette.purple).darken(0.7).alpha(0.9)}, ${Color(palette.blue).darken(0.7).alpha(0.9)}, ${Color(palette.teal).darken(0.7).alpha(0.9)})`,
  },
  NavButton: {
    textAlign: 'center',
    display: 'inline-block',
    textDecoration: 'none',
    lineHeight: '2.4rem',
    width: '6rem',
    height: '2.4rem',
    borderRadius: '5px',
    margin: '.5rem',
    color: 'rgb(230, 230, 230)',
    fontSize: '1.3rem',
    fontWeight: '500',
    transition: 'all .3s',
    '&:hover': {
      color: palette.blue
    }
  },
  NavButtonMobile: {
    extend: 'NavButton',
    width: '5rem',
    fontSize: '1rem'
  },
  Footer: {
    composes: ['$FlexRow', '$FlexCenter'],
    height: '9vh',
    bottom: '0',
    zIndex: '20000'
  },
  EditButton: {
    color: palette.lightFont,
    fontWeight: '200',
    transition: 'color .5s',
    marginLeft: '1rem',
    '&:hover': {
      color: palette.orange,
      cursor: 'pointer'
    }
  },
  FooterGroup: {
    height: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '1rem'
  },
  IconLink: {
    textDecoration: 'none',
    fontSize: '1.5rem',
    fontWeight: '100',
    color: 'rgb(160, 160, 160)',
    transition: 'color .5s',
    margin: '0rem .3rem',
    '&:hover': {
      color: palette.blue
    }
  },
  IconLinkMobile: {
    textDecoration: 'none',
    fontSize: '1.5rem',
    fontWeight: '100',
    color: 'rgb(160, 160, 160)',
    transition: 'color .5s',
    // margin: '0rem .1rem',
    '&:hover': {
      color: palette.blue
    }
  },
  Link: {
    composes: '$IconLink',
    fontSize: '1rem',
    textDecoration: 'none'
  }
}

const mapStateToProps = state => {
  return {
    user: state.mainState.user
  }
}

export default withRouter(connect(mapStateToProps)(injectSheet(styles)(LandingPage)))



// WEBPACK FOOTER //
// ./src/js/Components/LandingPage/LandingPage.jsx